import { __assign, __extends } from "tslib";
import * as React from 'react';
import { AppBaseButton } from '@ms/app-commanding-ui/lib/UISurfaces/controls/AppBaseButton';
import { concatStyleSets } from '@fluentui/react/lib/Styling';
import { getHeaderButtonStyles } from './HeaderButton.styles';
var HeaderButton = /** @class */ (function (_super) {
    __extends(HeaderButton, _super);
    function HeaderButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderButton.prototype.render = function () {
        var colors = this.props.colors;
        var buttonStyles = getHeaderButtonStyles(colors);
        if (this.props.styles) {
            buttonStyles = concatStyleSets(buttonStyles, this.props.styles);
        }
        // VSO: Bug 3572292: Investigate usage of AppButton in HeaderButton
        return React.createElement(AppBaseButton, __assign({}, this.props, { styles: buttonStyles }));
    };
    return HeaderButton;
}(React.PureComponent));
export { HeaderButton };
//# sourceMappingURL=HeaderButton.js.map